// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { withAppSnackbar } from 'atoms/AppSnackbar'
import { getWidgetCode } from 'utils/widget'

// Styles
const styles = theme => ({
  root: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.fontSize * 0.8,
    display: 'block',
    borderRadius: 8,
    border: 0,
    resize: 'none',
    color: theme.palette.text.secondary,
    background: theme.palette.grey['200'],
    width: '100%',
    height: 100,
    padding: 15 * 0.75,
    '&:focus': {
      outline: 0,
    },
  },
})

export default
@withStyles(styles)
@withAppSnackbar()
class WidgetCode extends Component {
  static propTypes = {
    domain: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    showAppSnackbar: PropTypes.func.isRequired,
  }

  handleTextareaFocus = () => {
    const { showAppSnackbar } = this.props
    try {
      setTimeout(() => {
        this.textarea.select()
        this.textarea.setSelectionRange(0, 9999)
        document.execCommand('copy')
        showAppSnackbar('Code copied to clipboard!')
      }, 100)
    } catch (e) {
      // do nothing
    }
  }

  textareaRef = (node) => {
    this.textarea = node
  }

  render() {
    const { domain, classes } = this.props
    return (
      <textarea
        className={classes.root}
        ref={this.textareaRef}
        onFocus={this.handleTextareaFocus}
        value={getWidgetCode({ domain })}
        readOnly
      />
    )
  }
}
